/**
 * Location options for restaurant (city/area). Used in location dropdown and to populate app with location-specific content.
 */
export const LOCATION_OPTIONS = [
  { value: 'Boston', label: 'Boston' },
  { value: 'Cambridge', label: 'Cambridge' },
  { value: 'Somerville', label: 'Somerville' },
  { value: 'Brookline', label: 'Brookline' },
  { value: 'Quincy', label: 'Quincy' },
  { value: 'Newton', label: 'Newton' },
  { value: 'Worcester', label: 'Worcester' },
  { value: 'Springfield', label: 'Springfield' },
  { value: 'Other MA', label: 'Other (Massachusetts)' },
  { value: 'Other', label: 'Other' }
];

export const DEFAULT_LOCATION = 'Boston';
